export const ConsultationIcon = ({ color = "#784EFF" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_110_16062)">
        <path
          opacity="0.2"
          d="M18 6.5H3C2.58579 6.5 2.25 6.83579 2.25 7.25V17.75C2.25 18.1642 2.58579 18.5 3 18.5H18C18.4142 18.5 18.75 18.1642 18.75 17.75V7.25C18.75 6.83579 18.4142 6.5 18 6.5Z"
          fill={color}
        />
        <path
          d="M18 6.5H3C2.58579 6.5 2.25 6.83579 2.25 7.25V17.75C2.25 18.1642 2.58579 18.5 3 18.5H18C18.4142 18.5 18.75 18.1642 18.75 17.75V7.25C18.75 6.83579 18.4142 6.5 18 6.5Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 11L23.25 8V17L18.75 14"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_110_16062">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
